import { Api } from "api";

export const getAdminLogs = async (page?: number) => {
  let url = "users/v1/admin/logs";
  const res = await Api.get(`${url}`, {
    params: { page, sort: 'DESC' },
  });
  return res.data;
};
